import React, { Component } from 'react';
import { connect } from 'react-redux';
import { refreshView, showNotification, translate } from 'ra-core';
import { defaultListProps } from '~constants/config';
import { List, TextField, DateField } from 'react-admin';
import Button from '@material-ui/core/Button';
import RefreshIcon from '@material-ui/icons/Refresh';
import CustomDatagrid from '~components/CustomDatagrid';
import api from '~config/api';

const POLL_MS = 5000;

// Statuses for which re-queuing ingest makes sense.
const REPROCESSABLE = ['PROCESSING', 'FAILED'];

function ReprocessLayerButtonBase({ record = {}, dispatch, translate: t }) {
  if (!REPROCESSABLE.includes(record.status)) {
    return null;
  }

  const handleReprocess = () => {
    api.post(`/layers/${record.id}/reingest/`).then(response => {
      if (response.ok) {
        dispatch(showNotification(t('layers.reprocessStarted')));
      } else {
        dispatch(showNotification(t('layers.reprocessError'), 'warning'));
      }
    });
  };

  return (
    <Button color="primary" onClick={handleReprocess} size="small">
      <RefreshIcon style={{ marginRight: 4 }} fontSize="small" />
      {t('buttons.reprocessLayer')}
    </Button>
  );
}

const ReprocessLayerButton = connect()(translate(ReprocessLayerButtonBase));

class LayersList extends Component {
  componentDidMount() {
    this.interval = setInterval(() => this.props.refreshView(), POLL_MS);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { refreshView: _unused, ...listProps } = this.props;
    return (
      <List {...defaultListProps} {...listProps}>
        <CustomDatagrid>
          <TextField source="name" label="Nombre" />
          <TextField source="status" label="Estado" />
          <TextField source="geometryType" label="Geometría" />
          <TextField source="featureCount" label="Features" />
          <TextField source="errorMessage" label="Error" />
          <DateField source="createdAt" label="Creada" showTime />
          <ReprocessLayerButton />
        </CustomDatagrid>
      </List>
    );
  }
}

export default connect(null, { refreshView })(LayersList);
